// サブメニュー開閉制御
// ヘッダー内で a.-has-submenu をホバー / フォーカス / タッチした際に直下の .submenu に -open を付け外しする。
// アクセシビリティを考慮し focus / blur でも開閉、外側クリックでクローズ。
// 想定マークアップ: <li><a class="-has-submenu">..</a><ul class="submenu">...</ul></li>

document.addEventListener("DOMContentLoaded", () => {
  // ヘッダー専用 data 属性でスコープ分離
  const HEADER_ROOT_SELECTOR = "[data-header-nav-root]";
  const TRIGGER_SELECTOR = "[data-header-submenu-trigger]";
  const SUBMENU_SELECTOR = "[data-header-submenu]";
  const OPEN_CLASS = "-open";
  const DESKTOP_MIN = 1001; // 1001px 以上: ホバー / フォーカスで開閉。1000px 以下: クリック/タップでトグル。
  const isDesktop = () => window.innerWidth >= DESKTOP_MIN;

  const headerRoot = document.querySelector(HEADER_ROOT_SELECTOR);
  if (!headerRoot) return;
  const triggers = headerRoot.querySelectorAll(TRIGGER_SELECTOR);
  if (!triggers.length) return;

  // ヘッダー専用: .mainmenu 配下のみを閉じるようスコープ限定
  function closeAll(except) {
    headerRoot
      .querySelectorAll(SUBMENU_SELECTOR + "." + OPEN_CLASS)
      .forEach((ul) => {
        if (!except || ul !== except) ul.classList.remove(OPEN_CLASS);
      });
  }

  triggers.forEach((trigger) => {
    const li = trigger.closest("[data-header-submenu-wrapper]");
    if (!li) return;
    const submenu = li.querySelector(":scope > " + SUBMENU_SELECTOR);
    if (!submenu) return;

    // 初期は閉じておく
    submenu.classList.remove(OPEN_CLASS);

    let hideTimer = null;

    const open = () => {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      if (isDesktop()) {
        // デスクトップはアコーディオン
        closeAll(submenu);
      }
      submenu.classList.add(OPEN_CLASS);
      trigger.setAttribute("aria-expanded", "true");
    };
    const scheduleClose = () => {
      if (!isDesktop()) return; // モバイル時はホバー閉じ不要
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        submenu.classList.remove(OPEN_CLASS);
        trigger.setAttribute("aria-expanded", "false");
      }, 150); // マウス移動の遊び時間
    };
    const immediateClose = () => {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      submenu.classList.remove(OPEN_CLASS);
      trigger.setAttribute("aria-expanded", "false");
    };
    const toggle = () => {
      if (submenu.classList.contains(OPEN_CLASS)) {
        immediateClose();
      } else {
        open();
      }
    };

    // ARIA 初期化
    trigger.setAttribute("aria-haspopup", "true");
    trigger.setAttribute("aria-expanded", "false");
    submenu.setAttribute("role", "menu");

    // ホバー (デスクトップ幅のみ有効)
    const hoverOpen = () => {
      if (isDesktop()) open();
    };
    const hoverScheduleClose = () => {
      if (isDesktop()) scheduleClose();
    };
    trigger.addEventListener("mouseenter", hoverOpen);
    trigger.addEventListener("mouseleave", hoverScheduleClose);
    submenu.addEventListener("mouseenter", hoverOpen);
    submenu.addEventListener("mouseleave", hoverScheduleClose);

    // フォーカス (キーボード操作)
    trigger.addEventListener("focus", () => {
      if (isDesktop()) open();
    });
    // サブメニュー内フォーカス維持
    const focusables = submenu.querySelectorAll(
      'a, button, [tabindex]:not([tabindex="-1"])'
    );
    focusables.forEach((el) => {
      el.addEventListener("focus", open);
      el.addEventListener("blur", (e) => {
        // 関連ターゲットがサブメニュー内に無ければ閉じる
        const next = e.relatedTarget;
        if (!next || !submenu.contains(next)) scheduleClose();
      });
    });

    // クリック / タッチ: 最初のタップで開く、開いている状態で再タップなら閉じる（href が無い想定）
    trigger.addEventListener("click", (e) => {
      if (isDesktop()) {
        // デスクトップ: クリックはナビ遷移優先。必要なら preventDefault で toggle へ変更可。
        return;
      }
      // モバイル: クリック/タップでトグル (ナビ遷移はさせない)
      e.preventDefault();
      toggle();
    });
  });

  // 外側クリックで全て閉じる (ヘッダー領域のみ / フッターは対象外)
  document.addEventListener("click", (e) => {
    // モバイルでは外側クリック閉じ無効（要件）
    if (!isDesktop()) return;
    const inHeaderMenu = e.target.closest(HEADER_ROOT_SELECTOR);
    const inFooterMenu = e.target.closest("[data-footer-submenu-root]");
    if (!inHeaderMenu && !inFooterMenu) {
      closeAll();
    }
  });

  // ESC キーで閉じる
  document.addEventListener("keydown", (e) => {
    if (!isDesktop()) return; // モバイル幅では無効
    if (e.key === "Escape") {
      closeAll();
    }
  });

  // 幅が閾値を跨いだ時のクリーンアップ (デスクトップ->モバイル で開いていたものを閉じる)
  window.addEventListener("resize", () => {
    // デスクトップ->モバイル移行時に開いていたものは閉じる
    if (!isDesktop()) {
      closeAll();
    }
  });
});
